module.exports = __webpack_public_path__ + "img/empregabilidade.41595667.svg";